import { links } from "@layouts/NavigationV2"

export const data = [
  {
    columnKey: 1,
    items: [
      {
        title: "Traqq features",
        href: links.FEATURES.href,
        subItems: [
          {
            ...links.SMART_TIME_TRACKING,
            title: "Time tracking software",
          },
          {
            ...links.ATTENDANCE_AND_TIME_CARDS,
            title: "Work schedules, attendance & breaks",
          },
          {
            ...links.CUSTOM_REPORTS,
            title: "Time & compliance reporting",
          },
          {
            ...links.PAY_RATES,
            title: "Pay rates & automated invoicing",
          },
          {
            ...links.PTO_AND_LEAVE,
            title: "PTO & leave management",
          },
          {
            ...links.TEAM_MANAGEMENT,
            title: "Team management software",
          },
          {
            ...links.ROLES_AND_PERMISSIONS,
            title: "Roles & permissions",
          },
          {
            ...links.TIMESHEETS_AND_EXPENSES,
          },
          {
            ...links.TIME_AND_FINANCIAL_DASHBOARD,
          },
          {
            ...links.CLIENTS_PROJECTS_AND_TASKS,
          },
          {
            title: "Integrations",
            href: "/product/integrations/",
          },
          /*{
            ...links.WORK_ANOMALIES,
            title: "Work time monitoring",
          },
          {
            ...links.AI_TIME_TRACKING_TOOLS,
            title: "AI time tracking tools",
          },*/
        ],
      },
      {
        title: "Use cases",
        href: links.USE_CASES.href,
        subItems: [
          {
            ...links.FOR_ENTERPRISES,
            title: "For enterprises & large organizations",
          },
          {
            ...links.FOR_SMALL_AND_MEDIUM_BUSINESSES,
            title: "For small & medium businesses",
          },
          {
            ...links.FOR_AGENCIES,
            title: "For agencies",
          },
          {
            ...links.FOR_REMOTE_TEAMS,
            title: "For hybrid & remote teams",
          },
          {
            ...links.FOR_FREELANCERS,
            title: "For independent contractors",
          },
          {
            ...links.FOR_FREELANCERS,
            title: "For freelancers & solo entrepreneurs",
          },
        ],
      },
    ],
  },
  {
    columnKey: 2,
    items: [
      {
        title: "Help center",
        href: links.TIME_TRACKING_SUPPORT.href,
        subItems: [
          {
            ...links.GETTING_STARTED,
          },
          {
            title: "Tracking time",
            href: "/support/time-tracking",
          },
          {
            title: "Desktop apps",
            href: "/support/desktop-app",
          },
          {
            ...links.MANAGING_TEAMS_PERMISSIONS,
          },
          {
            ...links.WORK_ATTENDANCE,
          },
          {
            title: "Team visibility tools",
            href: "/support/team-visibility",
          },
          {
            ...links.PAY_RATES_INVOICES,
          },
          {
            ...links.CLIENTS_PROJECTS_TASKS,
          },
          {
            ...links.TIMESHEETS_EXPENSES,
          },
          {
            ...links.REPORTS,
          },
          {
            ...links.BROWSER_EXTENSIONS,
          },
          {
            title: "Subscription",
            href: "/support/subscription",
          },
        ],
      },
      {
        title: "Company",
        href: links.COMPANY.href,
        subItems: [
          {
            ...links.ABOUT_US,
            title: "About us",
          },
          {
            ...links.CONTACT_US,
            title: "Contact us",
          },
          {
            ...links.BLOG,
            title: "Blog",
          },
          {
            ...links.PRODUCT_UPDATES,
            title: "Product updates",
          },
          /*{
            ...links.REQUEST_DEMO,
            title: "Request a demo",
          },*/
          {
            ...links.PRICING,
            title: "Pricing",
          },
          {
            ...links.TIME_TRACKING_SUPPORT,
            title: "Time tracking help",
          },
        ],
      },
    ],
  },
  {
    columnKey: 3,
    items: [
      {
        title: links.TOOLS_AND_CALCULATORS.title,
        href: links.TOOLS_AND_CALCULATORS.href,
        subItems: [
          links.TODO_LIST_TEMPLATES,
          {
            href: "/tools/timesheet-templates/",
            title: "Timesheet templates",
          },
          links.EXPENSE_REPORT_TEMPLATES,
          {
            ...links.POMODORO_TIMER,
            title: "Pomodoro timer",
          },
          {
            ...links.COUNTDOWN_TIMERS_WITH_ALARM,
            title: "Online timer with alarm",
          },
          {
            ...links.STOPWATCH,
            title: "Online stopwatch",
          },
          links.MILITARY_TIME_CONVERTER,
          {
            title: "Pay stub templates",
            href: "/product/tools/expense-report-templates/",
          },
          {
            title: "Decimal hours converter",
            href: "/tools/time-converter-calculator/",
          },
          links.SALARY_CALCULATOR,
          {
            ...links.TIME_SHEET_CALCULATOR_TOOL,
            title: "Timesheet calculator"
          }
        ],
      },
    ],
  },
]
